export var AuditLogAuthStatus;
(function (AuditLogAuthStatus) {
    AuditLogAuthStatus["Success"] = "SUCCESS";
    AuditLogAuthStatus["Failure"] = "FAILURE";
    AuditLogAuthStatus["InProgress"] = "IN_PROGRESS";
})(AuditLogAuthStatus || (AuditLogAuthStatus = {}));
